<script>
  const ethereum_request = (method, ...params) => ethereum.request({ method , params })
  import Sign from './personal_sign.svelte'
</script>

{#if !(window.ethereum && window.ethereum.isMetaMask)}
  missing <a href="https://metamask.io">metamask</a>
{:else}
  {#await ethereum_request('eth_requestAccounts')}
    connecting ...
  {:then accounts}
    <Sign address={accounts[0]}
          {ethereum_request}/>
  {:catch error}
    error: {error.message}
  {/await}
{/if}
